/**
 * tdesign v0.46.2
 * (c) 2022 tdesign
 * @license MIT
 */

var primaryTableProps = {
  asyncLoading: {
    type: [String, Function]
  },
  columnController: {
    type: Object
  },
  columnControllerVisible: {
    type: Boolean,
    "default": void 0
  },
  defaultColumnControllerVisible: {
    type: Boolean,
    "default": void 0
  },
  columns: {
    type: Array,
    "default": function _default() {
      return [];
    }
  },
  displayColumns: {
    type: Array,
    "default": void 0
  },
  defaultDisplayColumns: {
    type: Array
  },
  dragSort: {
    type: String,
    validator: function validator(val) {
      if (!val) return true;
      return ["row", "row-handler", "col", "row-handler-col", "drag-col"].includes(val);
    }
  },
  dragSortOptions: {
    type: Object
  },
  editableCellState: {
    type: Function
  },
  editableRowKeys: {
    type: Array
  },
  expandIcon: {
    type: [Boolean, Function],
    "default": true
  },
  expandOnRowClick: Boolean,
  expandedRow: {
    type: [String, Function]
  },
  expandedRowKeys: {
    type: Array,
    "default": void 0
  },
  defaultExpandedRowKeys: {
    type: Array,
    "default": function _default() {
      return [];
    }
  },
  filterIcon: {
    type: Function
  },
  filterRow: {
    type: [String, Function]
  },
  filterValue: {
    type: Object,
    "default": void 0
  },
  defaultFilterValue: {
    type: Object
  },
  hideSortTips: Boolean,
  indeterminateSelectedRowKeys: {
    type: Array
  },
  multipleSort: Boolean,
  selectedRowKeys: {
    type: Array,
    "default": void 0
  },
  defaultSelectedRowKeys: {
    type: Array,
    "default": function _default() {
      return [];
    }
  },
  sort: {
    type: [Object, Array],
    "default": void 0
  },
  defaultSort: {
    type: [Object, Array]
  },
  sortIcon: {
    type: Function
  },
  sortOnRowDraggable: Boolean,
  onAsyncLoadingClick: Function,
  onCellClick: Function,
  onChange: Function,
  onColumnChange: Function,
  onColumnControllerVisibleChange: Function,
  onDataChange: Function,
  onDisplayColumnsChange: Function,
  onDragSort: Function,
  onExpandChange: Function,
  onFilterChange: Function,
  onRowEdit: Function,
  onRowValidate: Function,
  onSelectChange: Function,
  onSortChange: Function,
  onValidate: Function
};

export { primaryTableProps as default };
//# sourceMappingURL=primary-table-props.js.map
